<template>
  <div class="content">
    <!-- <div class="tishi">提交资料即可开始沟通，否则医生无法收到复诊请求，如有问题请联系客服 010-67289955</div> -->
    <div class="border-card">
      <div class="pat-head">
        <div class="pat-people">
          就诊人
          <p>{{ patientinfo.realname }}</p>
          <span
            >（{{ patientinfo.sex == 1 ? "男" : "女" }}·{{
              patientinfo.age
            }}岁）</span
          >
        </div>
      </div>
      <div class="shenti">
        <div>
          <input
            type="text"
            oninput = "value=value.replace(/[^\d]/g,'')"
            placeholder="身高"
            v-model="patientinfo.height"
            maxlength="4"
          />
          <span>cm</span>
        </div>
        <div>
          <input
            type="text"
            oninput = "value=value.replace(/[^\d]/g,'')"
            placeholder="体重"
            v-model="patientinfo.weight"
            maxlength="4"
          />
          <span>kg</span>
        </div>
        <div class="select-address">
          <select name="diqu" v-model="patientinfo.address">
            <option value="选择地区">选择地区</option>
            <option v-for="item in regions" :value="item.region_name">
              {{ item.region_name }}
            </option>
          </select>
          <img
            class="select-img"
            src="../../../static/icons/arrow_bottom@3x.png"
          />
        </div>
      </div>
      <div class="pat-phone">
        <div class="pnum">
          <p>{{ patientinfo.telphone }}</p>
          <span>*用于接听电话及服务通知</span>
        </div>
        <span @click="chagephone">修改</span>
      </div>
    </div>
    <div class="border-card">
      <h3 class="font-85">是否到线下医院就诊过？</h3>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_see == 2 }"
        @click="is_see = 2"
      >
        无
      </div>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_see == 1 }"
        @click="is_see = 1"
      >
        有
      </div>
      <br class="clear" />
    </div>
    <div class="border-card" v-if="patientinfo.sex == 2">
      <h3 class="font-85">特殊时期</h3>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_special == 2 }"
        @click="is_special = 2"
      >
        无
      </div>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_special == 1 }"
        @click="is_special = 1"
      >
        有
      </div>
      <br class="clear" />
    </div>

    <div class="border-card">
      <h3 class="font-85">过敏史</h3>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_allergy == 2 }"
        @click="is_allergy = 2"
      >
        无
      </div>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_allergy == 1 }"
        @click="is_allergy = 1"
      >
        有
      </div>
      <textarea
        v-if="is_allergy == 1"
        maxlength="500"
        placeholder="请输入您的过敏史"
        v-model="allergydetial"
      ></textarea>
      <br class="clear" />
    </div>
    <div class="border-card">
      <h3 class="font-85 title-tip">既往病史</h3>
      <p>若曾有肝肾损伤，请在此填写，并告知医生</p>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_case == 2 }"
        @click="is_case = 2"
      >
        无
      </div>
      <div
        class="pat-card jiuzhen font-85"
        :class="{ actives: is_case == 1 }"
        @click="is_case = 1"
      >
        有
      </div>
      <textarea
        v-if="is_case == 1"
        placeholder="请输入您的病史"
        maxlength="500"
        v-model="casedetial"
      ></textarea>
      <div class="clear"></div>
    </div>
    <div class="border-card" style="padding-bottom: 0.5rem">
      <h3 class="title-tip">检查资料上传</h3>
      <p class="other-data">
        如有相关的检验报告或化验单，请上传照片，以便医生更准确的为您诊疗
      </p>
      <div>
        <div
          class="upload-img"
          v-for="(item, index) in otherimg"
          :key="index"
          v-if="index < 9"
        >
          <img :src="item" alt />
        </div>
        <div class="upload-img up-loading" v-if="qiloading">
          <img src="../../../static/icons/loading.gif" />
        </div>
        <div class="upload-img" v-if="otherimg.length < 9">
          <i class="icon icon-add-add"></i>
          <span class="upload-txt">点击上传</span>
          <input
            type="file"
            accept="image/*"
            @change="changeShe('otherimg')"
            ref="otherimg"
          />
        </div>
      </div>
      <div class="clear"></div>
      <h3 class="title-tip">舌照与面照上传</h3>
      <p>请上传清晰的舌苔和舌底及面部素颜彩色照片</p>
      <div>
        <div
          class="upload-img"
          v-for="(item, index) in tongue"
          :key="index"
          v-if="index < 9"
        >
          <img :src="item" alt />
        </div>
        <div class="upload-img up-loading" v-if="sheloading">
          <img src="../../../static/icons/loading.gif" />
        </div>
        <div class="upload-img" v-if="tongue.length < 9">
          <i class="icon icon-add-add"></i>
          <span class="upload-txt">点击上传</span>
          <input
            type="file"
            accept="image/*"
            @change="changeShe('tongue')"
            ref="tongue"
          />
        </div>
      </div>
      <div class="clear"></div>
      <!--<h3 class="title-tip">面照上传</h3>
      <p>请上传清晰的面部素颜彩色照片</p>
      <div>
        <div
          class="upload-img"
          v-for="(item, index) in faceimg"
          :key="index"
          v-if="index < 9"
        >
          <img :src="item" alt />
        </div>
        <div class="upload-img up-loading" v-if="mianloading">
          <img src="../../../static/icons/loading.gif" />
        </div>
        <div class="upload-img" v-if="faceimg.length < 9">
          <i class="icon icon-add-add"></i>
          <span class="upload-txt">点击上传</span>
          <input
            type="file"
            accept="image/*"
            @change="changeShe('faceimg')"
            ref="faceimg"
          />
        </div>
      </div>
      <br class="clear" />-->
    </div>
    <div class="bottom">
      <!-- <div class="checks">
        <i class="icon icon-check" :class="{'icon-checked':tongyi == 1}" @click="xieyi"></i>
        <p>
          点击即同意
          <span style="color:rgba(24,144,255,1);" @click="handlePdf(1)">《用户注册协议》(包含互联网诊疗风险告知及知情同意书)</span>及
          <span style="color:rgba(24,144,255,1);" @click="handlePdf(2)">《法律声明与隐私政策》</span>
        </p>
      </div> -->
      <div class="btns">
        <button class="submit-btn f_c_c" @click="subwenzhen">立即提交</button>
      </div>
    </div>
    <div class="mask" v-if="maskshow">
      <div class="phone-window">
        <div class="phone-cont">
          <h3>修改手机号</h3>
          <input type="text" placeholder="请输入您的手机号" v-model="phone" />
          <input
            type="text"
            placeholder="验证码"
            class="yanzheng-input"
            v-model="code"
            maxlength="4"
          />
          <button class="yanzheng-btn" @click="getCode" :disabled="disabled">
            {{ !disabled ? "获取验证码" : time + "s后重试" }}
          </button>
        </div>
        <div class="phone-btm">
          <div class="phone-btn quxiao" @click="quxiao">取消</div>
          <div class="phone-btn queren" @click="submitCode">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";

export default {
  name: "pat_content",
  data() {
    return {
      tongyi: 1,
      oid: "",
      patientinfo: {
        height: "",
        weight: "",
        address: "",
        telphone:""
      },
      regions: [],
      is_special: 2,
      is_case: "",
      is_allergy: "",
      is_see: "",
      casedetial: "",
      docid: "",
      nextshow: true,
      phone: "",
      code: "",
      maskshow: false,
      time: 60,
      disabled: false,
      allergydetial: "",
      otherimg: [],
      tongue: [],
      faceimg: [],
      qiloading: false,
      sheloading: false,
      mianloading: false,
      case_id: "",
      is_save:false,
      description:""
    };
  },
  methods: {
    changeShe(dataname) {
      let inputDOM;
      let imglist;
      switch (dataname) {
        case "tongue":
          inputDOM = this.$refs.tongue;
          imglist = this.tongue;
          this.sheloading = true;
          break;
        case "faceimg":
          inputDOM = this.$refs.faceimg;
          imglist = this.faceimg;
          this.mianloading = true;
          break;
        case "otherimg":
          inputDOM = this.$refs.otherimg;
          imglist = this.otherimg;
          this.qiloading = true;
          break;
      }
      if (imglist.length < 8) {
        let file = inputDOM.files[0]; // 通过DOM取文件数据
        let size = Math.floor(file.size / 1024); //计算文件的大小
        let formData = new FormData(); //new一个formData事件
        formData.append("file", file); //将file属性添加到formData里
        http.postFormData("/api/wap/public/upload", formData).then((res) => {
          imglist.push(res.data.path);
          this.sheloading = false;
          this.mianloading = false;
          this.qiloading = false;
        });
      } else {
        this.$toast.center("最多上传8张图片");
        this.sheloading = false;
        this.mianloading = false;
        this.qiloading = false;
      }
    },
    handlePdf(type) {
      let pdf = "";
      if (type == 1) {
        pdf = "user_register_protocol.pdf";
      } else if (type == 2) {
        pdf = "legal_notice.pdf";
      }
      this.$router.push({
        name: "pdf_template",
        query: {
          pdf: pdf,
        },
      });
    },
    quxiao() {
      this.maskshow = false;
    },
    xieyi() {
      if (this.tongyi == 1) {
        this.tongyi = 2;
      } else {
        this.tongyi = 1;
      }
    },
    chagephone() {
      if (this.maskshow) {
        this.maskshow = false;
      } else {
        this.maskshow = true;
      }
    },
    timeOut() {
      this.timerOut = setTimeout(() => {
        if (this.time == 0) {
          clearTimeout(this.timerOut);
          this.timerOut = null;
          this.disabled = false;
          this.time = 60;
          return false;
        }
        this.time--;
        this.timeOut();
      }, 1000);
    },
    casehistory() {
      http
        .post("/api/wap/case/history", {
          order_id: this.oid,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.case_info.id) {
              this.patientinfo = res.data.case_info;
              this.description = res.data.case_info.description;
            } else {
              this.patientinfo = res.data.patient_info;
              this.description = res.data.patient_info.description;
            }
            if (!this.patientinfo.address) {
              this.patientinfo.address = "选择地区";
            }
          }
        });
    },
    getregion() {
      http.post("/api/wap/public/region").then((res) => {
        console.log(res);
        this.regions = res.data;
      });
    },
    subwenzhen() {
      if (this.tongyi == 2) {
        this.$toast.center("请勾选协议");
        return;
      }
      if (this.patientinfo.address == "选择地区") {
        this.$toast.center("请选择地区");
        return;
      }
      if (!this.patientinfo.height) {
        this.$toast.center("请填写身高");
        return;
      }
      if (!this.patientinfo.weight) {
        this.$toast.center("请填写体重");
        return;
      }
      if (!this.is_see) {
        this.$toast.center("请选择是否到线下医院就诊过");
        return;
      }
      if (!this.is_allergy) {
        this.$toast.center("请选择过敏史");
        return;
      }
      if (this.is_case == 1 && !this.casedetial) {
        this.$toast.center("请填写既往病史");
        return;
      }
      let params = {
        id: this.case_id,
        pid: this.patientinfo.pid,
        sex: this.patientinfo.sex,
        docid: this.docid,
        age: this.patientinfo.age,
        username: this.patientinfo.realname,
        height: this.patientinfo.height,
        weight: this.patientinfo.weight,
        address: this.patientinfo.address,
        mobile: this.patientinfo.telphone,
        is_special: this.is_special,
        is_allergy: this.is_allergy,
        is_see: this.is_see,
        is_case: this.is_case,
        order_id: this.oid,
        casedetial: this.casedetial,
        allergydetial: this.allergydetial,
        tongue: this.tongue,
        faceimg: this.faceimg,
        otherimg: this.otherimg,
        description:this.description
      };
      http
        .post("/api/wap/case/edit", params)
        .then((res) => {
          if (res.errno == 0) {
            this.is_save = true;
            sessionStorage.setItem(this.oid,null);
            this.$router.push({ path: "/chat", query: this.$route.query });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // this.$router.push({
      //   name: "up_photos",
      //   params: {
      //     pid: this.patientinfo.pid,
      //     sex: this.patientinfo.sex,
      //     docid: this.docid,
      //     age: this.patientinfo.age,
      //     username: this.patientinfo.realname,
      //     height: this.patientinfo.height,
      //     weight: this.patientinfo.weight,
      //     address: this.patientinfo.address,
      //     mobile: this.patientinfo.telphone,
      //     is_special: this.is_special,
      //     is_allergy: this.is_allergy,
      //     is_see:this.is_see,
      //     is_case: this.is_case,
      //     order_id: this.oid,
      //     casedetial: this.casedetial,
      //     allergydetial:this.allergydetial,
      //     tongue:this.tongue,
      //     faceimg:this.faceimg,
      //     otherimg:this.otherimg,
      //   },
      // });
    },
    submitCode() {
      http
        .post("/api/wap/case/mobile", {
          mobile: this.phone,
          code: this.code,
          pid: this.patientinfo.pid,
        })
        .then((res) => {
          console.log(res);
          if (res.errno == 0) {
            this.$toast.center("修改成功");
            this.patientinfo.telphone = this.phone;
            this.maskshow = false;
          } else {
            this.$toast.center(res.errmsg);
          }
        });
    },
    getCode() {
      http
        .post("/api/wap/user/sendcode", {
          mobile: this.phone,
        })
        .then((res) => {
          if (res.errno == 0) {
            let timer = null;
            this.$toast.center("验证码发送成功");
            this.disabled = true;
            this.timeOut();
          } else {
            this.$toast.center(res.errmsg);
          }
        });
    },
    getInfo() {
      let patient_info = null;
      if(sessionStorage.getItem(this.oid)){
        patient_info = JSON.parse(sessionStorage.getItem(this.oid))
      }
      http
        .post("/api/wap/case/info", {
          order_id: this.oid,
        })
        .then((res) => {
          if (res.errno == 0) {
            let data = res.data;
            if (data) {
              this.patientinfo.realname = patient_info && patient_info.username ? patient_info.username : data.username ? data.username : this.patientinfo.realname;
              this.patientinfo.sex = patient_info && patient_info.sex ? patient_info.sex : data.sex ? data.sex : this.patientinfo.sex;
              this.patientinfo.age = patient_info && patient_info.age ? patient_info.age:data.age ? data.age : this.patientinfo.age;
              this.patientinfo.height = patient_info && patient_info.height ? patient_info.height : data.height ? data.height : this.patientinfo.height;
              this.patientinfo.weight = patient_info && patient_info.weight ? patient_info.weight : data.weight ? data.weight : this.patientinfo.weight;
              this.patientinfo.address = patient_info && patient_info.address ? patient_info.address : data.address? data.address: this.patientinfo.address;
              this.patientinfo.telphone = patient_info && patient_info.mobile ? patient_info.mobile : data.mobile? data.mobile: this.patientinfo.telphone;
              this.is_see = patient_info && patient_info.is_see ? patient_info.is_see : data.is_see ? data.is_see : this.is_see;
              this.is_special = patient_info && patient_info.is_special ? patient_info.is_special : data.is_special? data.is_special: this.is_special;
              this.is_allergy = patient_info && patient_info.is_allergy ? patient_info.is_allergy :data.is_allergy ? data.is_allergy: this.is_allergy;
              this.is_case = patient_info && patient_info.is_case ? patient_info.is_case : data.is_case ? data.is_case : this.is_case;
              this.tongue = patient_info && patient_info.tongue ? patient_info.tongue : data.tongue ? JSON.parse(data.tongue) : this.tongue;
              if(data.otherimg){
                this.otherimg = JSON.parse(data.otherimg);
              }else{
                this.otherimg = patient_info && patient_info.otherimg ? patient_info.otherimg : data.otherimg ? JSON.parse(data.otherimg) : this.otherimg;
              }

              this.faceimg = patient_info && patient_info.faceimg ? patient_info.faceimg : data.faceimg ? JSON.parse(data.faceimg) : this.faceimg;
              if(data.id){
                console.log('aasas',data.id)
                this.case_id = data.id;
              }else{
                this.case_id = patient_info && patient_info.case_id ? patient_info.case_id : data.id ? data.id : "";
              }
              this.allergydetial = patient_info && patient_info.allergydetial ? patient_info.allergydetial : data.allergydetial?data.allergydetial:this.allergydetial;
              this.casedetial = patient_info && patient_info.casedetial ? patient_info.casedetial : data.casedetial?data.casedetial:this.casedetial;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.oid = this.$route.query.orderid;
    this.docid = this.$route.query.doctorid;
    this.casehistory();
    this.getregion();
    this.getInfo();
    let appbox = document.getElementById("app");
    appbox.scrollTop = 0;
  },
  mounted() {},
  beforeDestroy(){
    if(!this.is_save){
      let data = {...this.patientinfo};
      data.case_id = this.case_id;
      data.docid = this.docid;
      data.is_special = this.is_special;
      data.is_allergy = this.is_allergy;
      data.is_see = this.is_see;
      data.oid = this.oid;
      data.casedetial = this.casedetial;
      data.allergydetial = this.allergydetial;
      data.tongue = this.tongue
      data.faceimg = this.faceimg;
      data.otherimg = this.otherimg;
      sessionStorage.setItem(this.oid,JSON.stringify(data))
    }
  }
};
</script>

<style scoped>
@import "./up_photos.css";
.f_c_c {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  padding: 0 0 3.45rem;
}
.btns {
  padding: 0.4rem 1rem;
  align-items: start;
}
.submit-btn {
  margin: 0;
  width: 100%;
  height: 2.2rem;
  background: linear-gradient(180deg, #43a5ff 0%, #4890ff 100%);
  box-shadow: 0px 0.2rem 0.2rem 0px rgba(24, 124, 255, 0.23);
  border-radius: 1.15rem;
  font-size: 0.75rem;
  color: #fff;
  font-weight: 400;
}
.pat-card.jiuzhen {
  border: 0.05rem solid rgba(239, 239, 244, 1);
  height: 2rem;
  line-height: 2rem;
  font-size: 0.8rem;
  text-align: center;
  width: 4rem;
  padding: 0;
  float: left;
}
.pat-card.jiuzhen + .pat-card.jiuzhen {
  margin-left: 1rem;
}
.pat-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  line-height: 1.3rem;
  position: relative;
}
.pat-head > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
}
.pat-people {
  width: auto;
  padding-right: 0.3rem;
  box-sizing: border-box;
}
.pat-people span {
  display: inline-block;
  width: 5.4rem;
}
.pat-people p {
  /* width:calc(100% - 5.4rem); */
}
.border-card {
  width: 100vw;
  margin: 0 auto;
  border: 0.05rem solid rgba(245, 245, 245, 1);
  border-radius: 0;
}
.border-card + .border-card {
  margin-top: 0.5rem;
}
.border-card > p {
  font-size: 0.6rem;
  color: #fa541c;
  margin-bottom: 0.5rem;
}
.border-card .pat-head p {
  width: auto;
  margin: 0 0 0 1rem;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
}
select[name="diqu"] {
  width: 3.25rem;
  padding: 0;
  border: none;
  font-size: 0.8rem;
  height: 1.2rem;
  -webkit-appearance: none;
  box-sizing: border-box;
  background: #fff;
}
.shenti {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.15rem;
}
.shenti > div {
  position: relative;
  width: 5rem;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.25);
}
.shenti > div span {
  position: absolute;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
  top: 0.5rem;
  right: 0.7rem;
  color: rgba(0, 0, 0, 0.65);
}
.shenti > div input {
  width: 100%;
  height: 2.2rem;
  border: 0.05rem solid rgba(0, 0, 0, 0.09);
  border-radius: 0.25rem;
  padding: 0.5rem 0.7rem;
  font-size: 0.8rem;
  -webkit-appearance: none;
  margin: 0;
  line-height: 1.2rem;
}
.pat-phone {
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.pnum {
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
.pnum span {
  font-size: 0.6rem;
  color: #fa541c;
  font-weight: 400;
}
.pat-phone > span {
  color: #1890ff;
  font-size: 0.8rem;
}
.border-card textarea {
  width: 100%;
  height: 4.2rem;
  border: none;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
  resize: none;
  padding: 0.5rem 0.7rem;
  font-size: 0.8rem;
  -webkit-appearance: none;
  background: #fafafa;
}
.phone-window {
  width: 14.5rem;
  background: #fff;
  border-radius: 0.4rem;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -7.65rem;
  margin-left: -7.25rem;
}
.phone-cont {
  padding: 1.2rem;
}
.phone-cont h3 {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  line-height: 1;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}
.border-card h3 {
  line-height: 1.3rem;
  font-size: 0.9rem;
  margin-bottom: 0.8rem;
}
input {
  height: 2.2rem;
  border: 0.05rem solid rgba(0, 0, 0, 0.09);
  border-radius: 0.2rem;
  line-height: 2.2rem;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  width: 100%;
  padding: 0 0.5rem;
  outline: none;
  -webkit-appearance: none;
}
.yanzheng-input {
  width: 6rem;
}
.yanzheng-btn {
  width: 5.25rem;
  height: 2.2rem;
  text-align: center;
  border-radius: 0.25rem;
  background-color: rgba(24, 144, 255, 0.12);
  border: 0.05rem solid rgba(24, 144, 255, 1);
  float: right;
  color: #1890ff;
  font-size: 0.8rem;
}
.yanzheng-btn:disabled {
  background-color: rgba(250, 250, 250, 1);
  border: 0.05rem solid rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.25);
}
.phone-btm {
  height: 2.4rem;
  width: 100%;
  border-top: 0.05rem solid rgba(0, 0, 0, 0.09);
  text-align: center;
  line-height: 2.4rem;
  font-size: 0.8rem;
  color: #1890ff;
}
.phone-btn {
  width: 50%;
  height: 2.4rem;
  float: left;
  border-right: 1px solid rgba(0, 0, 0, 0.09);
}
.phone-btn.queren {
  border: none;
}
.phone-btn.quxiao {
  color: rgba(0, 0, 0, 0.8);
}
.tishi {
  width: 100vw;
  padding: 1rem 0.5rem 0.7rem;
  box-sizing: border-box;
  line-height: 1rem;
  font-size: 0.6rem;
  color: rgba(212, 107, 8, 1);
  background-color: rgba(255, 247, 230, 1);
}
.select-img {
  position: absolute;
  top: 0.85rem;
  right: 0.5rem;
  width: 0.5rem;
  height: 0.5rem;
}
.checks p {
  width: calc(100% - 1.4rem);
}
.pat-card {
  width: calc(50vw - 2rem);
}
.pat-card.actives {
  background: #1890ff;
  color: #fff;
}
.bottom,
.bottom .btns {
  height: 3rem;
}
.select-address {
  border: 0.05rem solid rgba(0, 0, 0, 0.09);
  height: 2.2rem;
  border-radius: 0.25rem;
  line-height: 2.2rem;
  padding: 0 0.5rem;
}
.pnum p {
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  margin-bottom: 0.2rem;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/pat_content.vue